"use strict";

(function () {
  'use strict';

  angular.module('payment-service', []).factory('PaymentService', PaymentService);
  PaymentService.$inject = ['$http', '$q'];
  /* @ngInject */

  function PaymentService($http, $q) {
    function getCountries() {
      var defered = $q.defer();
      $http({
        method: 'GET',
        url: '/payment/countries'
      }).then(function (response) {
        defered.resolve(response.data);
      }, function (response) {
        defered.reject(response);
      });
      return defered.promise;
    }

    function getStates() {
      var defered = $q.defer();
      $http({
        method: 'GET',
        url: '/payment/states'
      }).then(function (response) {
        defered.resolve(response.data);
      }, function (response) {
        defered.reject(response);
      });
      return defered.promise;
    }

    function processPayment(paymentObj, adminCustDataId, transactionId) {
      var defered = $q.defer();
      $http.post('/payment/process/' + adminCustDataId + '/' + transactionId, paymentObj).then(function (response) {
        defered.resolve(response.data);
      }, function (response) {
        defered.reject(response.data);
      });
      return defered.promise;
    }

    return {
      getCountries: getCountries,
      getStates: getStates,
      processPayment: processPayment
    };
  }
})();